
<ng-container *ngIf="{
  row: columnData | async,
  adata: additionData | async
} as $">
<span *ngIf="$.row && $.adata.fetch_key" >{{ $.row[$.adata.fetch_key]  | DayAgo}} </span>
</ng-container>
